import { api } from '../api/client';

export function renderLogin(
  container: HTMLElement,
  onSuccess: () => void,
  onSignupClick: () => void
) {
  container.innerHTML = `
    <div class="auth-container">
      <div class="card">
        <h2 class="auth-title">Login</h2>
        <div id="login-error" class="alert alert-error" style="display: none;"></div>
        <form id="login-form">
          <div class="form-group">
            <label class="form-label" for="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              class="form-input"
              placeholder="you@example.com"
              required
            />
          </div>
          <div class="form-group">
            <label class="form-label" for="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              class="form-input"
              placeholder="Your password"
              required
            />
          </div>
          <button type="submit" class="btn btn-primary" style="width: 100%;">
            Login
          </button>
        </form>
        <div class="auth-footer">
          Don't have an account? <a href="#" id="signup-link">Sign up</a>
        </div>
      </div>
    </div>
  `;

  const form = document.getElementById('login-form') as HTMLFormElement;
  const errorDiv = document.getElementById('login-error') as HTMLElement;
  const signupLink = document.getElementById('signup-link') as HTMLElement;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorDiv.style.display = 'none';

    const email = (form.querySelector('#email') as HTMLInputElement).value;
    const password = (form.querySelector('#password') as HTMLInputElement).value;

    const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Logging in...';

    const response = await api.login(email, password);

    submitBtn.disabled = false;
    submitBtn.textContent = 'Login';

    if (response.success) {
      onSuccess();
    } else {
      errorDiv.textContent = response.error || 'Login failed';
      errorDiv.style.display = 'block';
    }
  });

  signupLink.addEventListener('click', (e) => {
    e.preventDefault();
    onSignupClick();
  });
}

export function renderSignup(
  container: HTMLElement,
  onSuccess: () => void,
  onLoginClick: () => void
) {
  container.innerHTML = `
    <div class="auth-container">
      <div class="card">
        <h2 class="auth-title">Create Account</h2>
        <div id="signup-error" class="alert alert-error" style="display: none;"></div>
        <form id="signup-form">
          <div class="form-group">
            <label class="form-label" for="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              class="form-input"
              placeholder="you@example.com"
              required
            />
          </div>
          <div class="form-group">
            <label class="form-label" for="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              class="form-input"
              placeholder="Min 8 chars, uppercase, lowercase, number"
              required
              minlength="8"
            />
          </div>
          <div class="form-group">
            <label class="form-label" for="confirm-password">Confirm Password</label>
            <input
              type="password"
              id="confirm-password"
              name="confirm-password"
              class="form-input"
              placeholder="Confirm your password"
              required
            />
          </div>
          <button type="submit" class="btn btn-primary" style="width: 100%;">
            Create Account
          </button>
        </form>
        <div class="auth-footer">
          Already have an account? <a href="#" id="login-link">Login</a>
        </div>
      </div>
    </div>
  `;

  const form = document.getElementById('signup-form') as HTMLFormElement;
  const errorDiv = document.getElementById('signup-error') as HTMLElement;
  const loginLink = document.getElementById('login-link') as HTMLElement;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errorDiv.style.display = 'none';

    const email = (form.querySelector('#email') as HTMLInputElement).value;
    const password = (form.querySelector('#password') as HTMLInputElement).value;
    const confirmPassword = (form.querySelector('#confirm-password') as HTMLInputElement).value;

    if (password !== confirmPassword) {
      errorDiv.textContent = 'Passwords do not match';
      errorDiv.style.display = 'block';
      return;
    }

    const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Creating account...';

    const response = await api.signup(email, password);

    submitBtn.disabled = false;
    submitBtn.textContent = 'Create Account';

    if (response.success) {
      onSuccess();
    } else {
      errorDiv.textContent = response.error || 'Signup failed';
      errorDiv.style.display = 'block';
    }
  });

  loginLink.addEventListener('click', (e) => {
    e.preventDefault();
    onLoginClick();
  });
}
